import React from "react";

// Widgets for customer page
import CustomerOrderTable from "./CustomerOrderTable";

const CustomerOrdersWidget = ({
  id,
  allCustomerData,
  setUpdatedData,
  setTrigger,
}) => (
  <CustomerOrderTable
    allCustomerData={allCustomerData}
    id={id}
    setUpdatedData={setUpdatedData}
    setTrigger={setTrigger}
  />
);

export default CustomerOrdersWidget;
